export default "__VITE_ASSET__59d954f5__"